import { FrecuentlyAskedQuestion } from "../types";
import FeedbackInput from "../ui/FeedbackInput/FeedbackInput";
// import FeedbackInput from "../ui/FeedbackInput/FeedbackInput";

const testingPhaseAnswerText =
  "Tu opinión nos ayuda a seguir mejorando la experiencia y construir una app cada vez mejor para todos nuestros usuarios.";

export const faqs: FrecuentlyAskedQuestion[] = [
  {
    value: "consultancy",
    question: "¿Cómo es el asesoramiento en Allaria?",
    answer:
      "Como cliente siempre contarás con un asesor financiero al cual podrás recurrir con consultas, dudas y expectativas. Él te brindará el mejor asesoramiento. También vas a tener acceso a información de mercado elaborada por nuestro equipo de Research.",
  },
  // {
  //   question: "¿Cuál es la diferencia entre la web clásica y DMA?",
  //   answer: (
  //     <>
  //       En{" "}
  //       <a
  //         href={"https://www.allaria.com.ar"}
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         www.allaria.com.ar
  //       </a>{" "}
  //       usted podrá visualizar sus boletos, su cuenta corriente, su tenencia,
  //       solicitar transferencias, visualizar y descargar sus reportes
  //       impositivos y rescatar-suscribir a Fondos Comunes de Inversión. En la
  //       plataforma DMA{" "}
  //       <a
  //         href={"https://dma.allaria.com.ar/"}
  //         target="_blank"
  //         rel="noopener noreferrer"
  //       >
  //         https://dma.allaria.com.ar/
  //       </a>{" "}
  //       podrá operar todos los instrumentos disponibles en el Mercado.
  //     </>
  //   ),
  // },
  {
    value: "expenses",
    question: "¿Qué gastos tengo por operar productos?",
    answer: (
      <>
        Solamente se cobra comisión por las operaciones de bolsa. Para conocer
        las comisiones hacé{" "}
        <a
          href="https://allaria.com.ar/doc/ArancelesComisiones.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          click aquí
        </a>
      </>
    ),
  },
  {
    value: "phone_theft",
    question: "¿Qué hacer si me roban/pierdo el teléfono?",
    answer:
      "Contactá a soporte vía mail, a atencionalcliente@allaria.com.ar para que bloqueemos cualquier ingreso a tus cuentas.",
  },
  {
    value: "deposits",
    question: "¿Cómo ingreso dinero a mi cuenta?",
    answer:
      "Desde Inicio > Ingresar vas a encontrar las cuentas habilitadas. Copiá y pegá el CBU o alias en tu banco y realiza la transferencia. Recordá que únicamente vas a poder ingresar dinero desde cuentas de tu titularidad.",
  },
  {
    value: "transfer_delays",
    question:
      "¿Cuánto tiempo tarda en transferirse el dinero de mi banco o billetera a mi cuenta?",
    answer:
      "Va a depender de los tiempos de tu entidad bancaria. Una vez que esté el dinero acreditado a la cuenta a la cual transferiste, lo vas a ver desde tu saldo disponible.",
  },
  {
    value: "withdrawals",
    question: "¿Cómo retiro dinero de mi cuenta?",
    answer: (
      <>
        Ingresá a Inicio &gt; Transferir. Elegí si querés retirar el dinero a
        una cuenta propia o a terceros si tenes tu cuenta de Allaria+ vinculada.
        <ul style={{ marginTop: "10px", marginLeft: "20px" }}>
          <li style={{ listStyleType: "disc", marginBottom: "8px" }}>
            Para cuentas propias cuenta bancaria, seleccioná la cuenta bancaria
            o billetera virtual agendada. Ingresá el monto a retirar y confirmá
            la operación. Recordá que únicamente vas a poder retirar dinero a
            cuentas de tu titularidad.
          </li>
          <li style={{ listStyleType: "disc" }}>
            Para terceros, si vinculaste tus cuentas podes hacerlo desde
            Allaria+.
          </li>
        </ul>
      </>
    ),
  },
  {
    value: "withdrawal_delays",
    question:
      "¿Cuánto tiempo tarda en llegarme el dinero al banco o billetera?",
    answer:
      "La solicitud se realiza inmediatamente. La demora en ver acreditado el dinero en tu cuenta bancaria o billetera virtual dependerá de los tiempos propios de la red de transferencias bancarias.",
  },
  {
    value: "testing_phase",
    question: "¿Querés dejarnos tu feedback?",
    answer: (
      <div className="flex flex-col gap-4">
        <p>{testingPhaseAnswerText}</p>
        <FeedbackInput />
      </div>
    ),
  },
];
